import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeLine: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconHomeLine"><Path fillRule="evenodd" clipRule="evenodd" d="M13.5677 1.87009C12.6524 1.13331 11.3476 1.13331 10.4323 1.87009L3.93234 7.10256C3.34282 7.57712 3 8.29318 3 9.04998V18.5C3 19.8807 4.11929 21 5.5 21H18.5C19.8807 21 21 19.8807 21 18.5V9.04998C21 8.29318 20.6572 7.57712 20.0677 7.10256L13.5677 1.87009ZM6.5 17C6.22386 17 6 17.2239 6 17.5C6 17.7761 6.22386 18 6.5 18H17.5C17.7761 18 18 17.7761 18 17.5C18 17.2239 17.7761 17 17.5 17H6.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeLine;
